import { Box, Card, Tab } from '@mui/material';
import { useRecordContext, useTranslate } from 'react-admin';
import UserOverviewCard from './UserOverviewCard';
import UserTransactionHistory from './UserTransactionHistory';
import { useEffect, useState } from 'react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import TokenHoldings from './TokenHoldings';
import DexTradeHistory from './DexTradeHistory';
import WalletList from './WalletList';
import TransferTable from './TransferTable';
import DexPositions from './DexPositions';
import DexCurrentOrders from './DexCurrentOrders';
import {
  PredictActivityMock,
  PredictOpenOrdersMock,
  PredictPositionsMock,
} from './PredictMockPanels';
import { TapGridActiveBids, TapGridClosedBids } from './TapGridBids';
import { PredictPositions, PredictTradeHistory } from './PredictPanels';

const UserDetail = () => {
  // const [tabMeme, setTabMeme] = useState('1');
  const [tabDex, setTabDex] = useState('3');
  const [tabPredict, setTabPredict] = useState('3');
  const [tabTapGrid, setTabTapGrid] = useState('2');
  const [tabActive, setTabActive] = useState('dex');
  const [selectedWallet, setSelectedWallet] = useState<any[]>([]);
  const t = useTranslate();
  const record = useRecordContext();

  useEffect(() => {
    if (tabActive === 'dex') {
      if (!record || !record.data) return;
      const filteredWallets = record?.data.wallets.filter(
        (w: any) => w.chainId === 0 && tabActive === 'dex' && w.tradeType !== 'PREDICT'
      );
      setSelectedWallet(filteredWallets);
    } else {
      setSelectedWallet([]);
    }
  }, [tabActive, record]);

  // const handleChangeMeme = (_event: React.SyntheticEvent, newValue: string) => {
  //   setTabMeme(newValue);
  // };

  const handleChangeDex = (_event: React.SyntheticEvent, newValue: string) => {
    setTabDex(newValue);
  };

  const handleChangePredict = (_event: React.SyntheticEvent, newValue: string) => {
    setTabPredict(newValue);
  };

  const handleChangeTapGrid = (_event: React.SyntheticEvent, newValue: string) => {
    setTabTapGrid(newValue);
  };

  const handleChangeActiveTab = (_event: React.SyntheticEvent, newValue: string) => {
    setTabActive(newValue);
  };

  return (
    <>
      <UserOverviewCard tabActive={tabActive} record={record} />
      <TransferTable record={record} isDialog={false} />
      <TabContext value={tabActive}>
        <TabList
          onChange={handleChangeActiveTab}
          sx={{
            '& .MuiTab-root': {
              flex: 1,
              minWidth: 'unset',
              maxWidth: 'unset',
            },
            mt: 3,
          }}
        >
          <Tab label={t('module.userInfo.tabDex')} value="dex" />
          {/* <Tab label={t('module.userInfo.tabMeme')} value="meme" /> */}
          <Tab label={t('module.userInfo.tabPredict')} value="predict" />
          <Tab label={t('module.userInfo.tabTapGrid')} value="tapgrid" />
        </TabList>
        <Card>
          {tabActive === 'meme' && (
            <WalletList onWalletSelect={setSelectedWallet} tabActive={tabActive} record={record} />
          )}
          <TabPanel value="dex">
            <TabContext value={tabDex}>
              <Box>
                <TabList onChange={handleChangeDex}>
                  <Tab label={t('module.userInfo.positions')} value="1" />
                  <Tab label={t('module.userInfo.currentOrders')} value="2" />
                  <Tab label={t('module.userInfo.tradeHistory')} value="3" />
                </TabList>
              </Box>
              <TabPanel value="1" sx={{ padding: '0' }}>
                <DexPositions selectedWallet={selectedWallet} />
              </TabPanel>
              <TabPanel value="2" sx={{ padding: '0' }}>
                <DexCurrentOrders selectedWallet={selectedWallet} />
              </TabPanel>
              <TabPanel value="3" sx={{ padding: '0' }}>
                <DexTradeHistory selectedWallet={selectedWallet} />
              </TabPanel>
            </TabContext>
          </TabPanel>
          {/* <TabPanel value="meme">
            <TabContext value={tabMeme}>
              <Box>
                <TabList onChange={handleChangeMeme}>
                  <Tab label={t('module.userInfo.holdings')} value="1" />
                  <Tab label={t('module.userInfo.activity')} value="2" />
                </TabList>
              </Box>
              <TabPanel value="1" sx={{ padding: '0' }}>
                <TokenHoldings selectedWallet={selectedWallet} />
              </TabPanel>
              <TabPanel value="2" sx={{ padding: '0' }}>
                <UserTransactionHistory selectedWallet={selectedWallet} />
              </TabPanel>
            </TabContext>
          </TabPanel> */}
          <TabPanel value="predict">
            <TabContext value={tabPredict}>
              <Box>
                <TabList onChange={handleChangePredict}>
                  {/* <Tab
                    label={t('module.userInfo.predictMock.openOrders', { _: 'Open Orders' })}
                    value="1"
                  /> */}
                  <Tab label={t('module.userInfo.positions')} value="2" />
                  <Tab label={t('module.userInfo.activity')} value="3" />
                </TabList>
              </Box>
              {/* <TabPanel value="1" sx={{ padding: '0' }}>
                <PredictOpenOrdersMock selectedWallet={selectedWallet} />
              </TabPanel> */}
              <TabPanel value="2" sx={{ padding: '0' }}>
                <PredictPositions record={record} />
              </TabPanel>
              <TabPanel value="3" sx={{ padding: '0' }}>
                <PredictTradeHistory record={record} />
              </TabPanel>
            </TabContext>
          </TabPanel>
          <TabPanel value="tapgrid">
            <TabContext value={tabTapGrid}>
              <Box>
                <TabList onChange={handleChangeTapGrid}>
                  <Tab label={t('module.userInfo.activeBids')} value="1" />
                  <Tab label={t('module.userInfo.closedBids')} value="2" />
                </TabList>
              </Box>
              <TabPanel value="1" sx={{ padding: '0' }}>
                <TapGridActiveBids record={record} />
              </TabPanel>
              <TabPanel value="2" sx={{ padding: '0' }}>
                <TapGridClosedBids record={record} />
              </TabPanel>
            </TabContext>
          </TabPanel>
        </Card>
      </TabContext>
    </>
  );
};

export default UserDetail;
